/* AMEHA Paris — scripts du thème */
(function () {
  'use strict';
  document.documentElement.classList.add('js');
  var A = window.AMEHA || { routes: {}, strings: {} };

  /* ---------- Apparition au défilement ---------- */
  function initReveal() {
    var els = document.querySelectorAll('.reveal');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- En-tête ---------- */
  function initHeader() {
    var header = document.querySelector('[data-header]');
    if (header) {
      var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > header.offsetTop + 10); };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
    var toggle = document.querySelector('[data-nav-toggle]');
    var nav = document.getElementById('SiteNav');
    if (toggle && nav) {
      toggle.addEventListener('click', function () {
        var open = nav.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      nav.addEventListener('click', function (e) {
        if (e.target.closest('a')) { nav.classList.remove('is-open'); toggle.setAttribute('aria-expanded', 'false'); }
      });
    }
    var bar = document.querySelector('[data-announcement]');
    var close = document.querySelector('[data-announcement-close]');
    try { if (bar && sessionStorage.getItem('ameha-bar-closed') === '1') bar.hidden = true; } catch (e) {}
    if (bar && close) {
      close.addEventListener('click', function () {
        bar.hidden = true;
        try { sessionStorage.setItem('ameha-bar-closed', '1'); } catch (e) {}
      });
    }
  }

  /* ---------- Ancres : compenser l'en-tête fixe ---------- */
  function initAnchors() {
    document.addEventListener('click', function (e) {
      var link = e.target.closest('a[href*="#"]');
      if (!link) return;
      var url = new URL(link.href, window.location.href);
      if (url.pathname !== window.location.pathname || !url.hash || url.hash === '#') return;
      var target = document.getElementById(decodeURIComponent(url.hash.slice(1)));
      if (!target) return;
      e.preventDefault();
      var header = document.querySelector('[data-header]');
      var offset = header ? header.offsetHeight : 0;
      window.scrollTo({ top: target.getBoundingClientRect().top + window.scrollY - offset + 1, behavior: 'smooth' });
      history.replaceState(null, '', url.hash);
    });
  }

  /* ---------- Panier ---------- */
  var drawer = document.getElementById('CartDrawer');
  var drawerEnabled = drawer && drawer.getAttribute('data-enabled') === 'true';

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('drawer-open');
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('drawer-open');
  }

  function refreshCart() {
    var url = (A.routes.root || '/') + '?sections=cart-drawer-items';
    return fetch(url.replace('//?', '/?'), { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data['cart-drawer-items'];
        if (!html) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var frag = tmp.querySelector('[data-cart-fragment]');
        if (!frag) return;
        var count = parseInt(frag.getAttribute('data-count'), 10) || 0;
        var body = drawer && drawer.querySelector('[data-cart-items]');
        if (body) body.innerHTML = frag.innerHTML;
        var foot = drawer && drawer.querySelector('[data-cart-foot]');
        if (foot) foot.hidden = count === 0;
        var sub = drawer && drawer.querySelector('[data-cart-subtotal]');
        if (sub) sub.innerHTML = frag.getAttribute('data-subtotal');
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = count;
          el.hidden = count === 0;
        });
      });
  }

  function initCart() {
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-cart-open]') && drawerEnabled) {
        e.preventDefault();
        openDrawer();
        return;
      }
      if (e.target.closest('[data-cart-close]')) { e.preventDefault(); closeDrawer(); return; }

      var qtyBtn = e.target.closest('[data-qty-change]');
      if (qtyBtn) {
        var line = qtyBtn.closest('[data-key]');
        if (!line) return;
        line.classList.add('is-loading');
        fetch((A.routes.cartChange || '/cart/change') + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: line.getAttribute('data-key'), quantity: parseInt(qtyBtn.getAttribute('data-qty-change'), 10) })
        }).then(refreshCart).catch(function () { line.classList.remove('is-loading'); alert(A.strings.error); });
      }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

    document.querySelectorAll('form[data-product-form]').forEach(function (form) {
      if (!drawerEnabled) return;
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = form.querySelector('[type="submit"]');
        if (btn) btn.classList.add('is-loading');
        fetch((A.routes.cartAdd || '/cart/add') + '.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        })
          .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
          .then(refreshCart)
          .then(openDrawer)
          .catch(function () { alert(A.strings.error); })
          .finally(function () { if (btn) btn.classList.remove('is-loading'); });
      });
    });
  }

  /* ---------- Fiche produit ---------- */
  function initProduct() {
    var main = document.querySelector('[data-main-image]');
    document.querySelectorAll('[data-thumb]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (main) { main.removeAttribute('srcset'); main.src = btn.getAttribute('data-thumb'); }
      });
    });
  }

  function init() { initReveal(); initHeader(); initAnchors(); initCart(); initProduct(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  document.addEventListener('shopify:section:load', initReveal);
})();
